<template>
    <button
        :id="buttonId"
        type="button"
        class="tl-display-document"
        @click="emit('download-document', { ...resource, componentId: id })"
    >
        <i
            style="margin-right: 8px"
            class="mi-document"
        />
        <p>{{ linkDescription }}</p>
        <i class="mi-download" />
    </button>
</template>

<script setup lang="ts">
import { computed, useId } from 'vue'
import type { DisplayDocumentPayload } from 'widget-components/types/DisplayDocument'

defineOptions({ inheritAttrs: false })

const props = defineProps<{
    id?: string
    resource: DisplayDocumentPayload
    linkDescription: string
}>()

const buttonId = computed(() => {
    return props.id || useId()
})

const emit = defineEmits<{
    (e: 'download-document', resource: DisplayDocumentPayload): void
}>()
</script>

<style lang="sass" scoped>
.tl-display-document
    width: 100%
    font-family: var(--font-family-primary)
    font-size: var(--tl-font-size, 16px)
    text-align: left
    display: flex
    align-items: center
    border-radius: var(--tl-container-border-radius)
    min-height: var(--tl-container-height, 45px)
    margin-top: var(--tl-cp-block-margin)
    margin-bottom: var(--tl-cp-block-margin)
    background-color: var(--tl-container-bg-color)
    border: 1px solid var(--tl-container-border-color)
    padding: 16px
    transition: opacity .3s ease-in-out, box-shadow .3s ease-in-out
    cursor: pointer

    p
        flex: 1

    i
        color: var(--tl-wc-primary-color)
        opacity: 0.5

    &:hover
        opacity: .5

    &:focus-visible
        outline: none
        box-shadow: 0 0 1px 1px var(--tl-container-primary-color)
</style>
